import { useState } from 'react';

import { Formik, type FormikValues } from 'formik';

export function FormikValidateAfterSubmit<T extends FormikValues>({
  children,
  validate,
  ...props
}: Parameters<typeof Formik<T>>[0]) {
  const [hasValidated, setHasValidated] = useState<boolean>(false);

  return (
    <Formik<T>
      validateOnChange={hasValidated}
      validateOnBlur={false}
      validate={values => {
        if (!hasValidated) {
          setHasValidated(true);
        }
        return validate ? validate(values) : {};
      }}
      {...props}
    >
      {children}
    </Formik>
  );
}
